import { jsx as _jsx } from "react/jsx-runtime";
import { SpecraIconButton } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
import { ArrowLeft } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { generateBreadcrumbsFromPath } from './Breadcrumbs';
// Home landings have nowhere to go back to, and no trail to show.
export const HOME_PATHS = new Set([
    '/',
    '/dashboard',
    '/growth/home'
]);
// The page one level up: the nearest linked breadcrumb before the current
// page (the last crumb), else home. Breadcrumb hrefs are always in-app paths, so this never leaves the app.
export function parentHref(pathname, homeHref) {
    const parent = generateBreadcrumbsFromPath(pathname).slice(0, -1).reverse().find((crumb)=>crumb.href)?.href;
    // The generator's root crumb points at '/', which is not the viewer's home.
    return !parent || parent === '/' ? homeHref : parent;
}
export function BackButton({ homeHref }) {
    const location = useLocation();
    const navigate = useNavigate();
    if (HOME_PATHS.has(location.pathname)) return null;
    // location.key is 'default' on the first entry of the session: nothing to go
    // back to inside the app, so fall through to the parent page.
    const goBack = ()=>location.key !== 'default' ? navigate(-1) : navigate(parentHref(location.pathname, homeHref));
    return /*#__PURE__*/ _jsx(SpecraIconButton, {
        className: "flex-shrink-0 text-muted-foreground hover:bg-muted hover:text-foreground",
        "data-testid": Testids.appNav.back,
        label: "Back",
        onClick: goBack,
        size: "sm",
        variant: "ghost",
        children: /*#__PURE__*/ _jsx(ArrowLeft, {
            "aria-hidden": "true",
            className: "size-4"
        })
    });
}
